module.exports = __webpack_public_path__ + "img/PDF.faf37554.svg";